import { OwnStayIngredient } from '@apps/main/modules/recipe/ingredients/ownStayIngredient';

import { IngredientType, SearchTermType } from '@libs/trip-planner-interfaces';
import type {
  ExposedActivityIngredient,
  ExposedOwnStayIngredient,
  SearchTerm,
} from '@libs/trip-planner-interfaces';

import { deserializeConstraintText } from '../ingredientSerializer/legacy/staySerializer/ownStaySerializer/deserialize';

import {
  createActivityIngredient,
  createExposedActivityIngredient,
} from './recipeSerializer.activity.helpers';

export function createExposedOwnStayIngredient(
  ownStayIngredient: OwnStayIngredient
): ExposedOwnStayIngredient {
  const { searchTerm, numberOfNights, subIngredients } = ownStayIngredient;

  return {
    ingredientType: IngredientType.OwnStay,
    destination:
      searchTerm.type === SearchTermType.FreeText
        ? searchTerm.freeText
        : undefined,
    polygonId:
      searchTerm.type === SearchTermType.PolygonId
        ? searchTerm.polygonId
        : undefined,
    hotelCodes:
      searchTerm.type === SearchTermType.HotelCode
        ? [searchTerm.hotelCode]
        : undefined,
    numberOfNights,
    subIngredients: subIngredients.length
      ? subIngredients.map(createExposedActivityIngredient)
      : undefined,
  };
}

export function createOwnStayIngredient(
  exposedOwnStayIngredient: ExposedOwnStayIngredient
): OwnStayIngredient {
  const { destination, numberOfNights, subIngredients, polygonId, hotelCodes } =
    exposedOwnStayIngredient;

  let searchTerm: SearchTerm;

  if (hotelCodes?.length && hotelCodes[0]) {
    searchTerm = { type: SearchTermType.HotelCode, hotelCode: hotelCodes[0] };
  } else if (polygonId) {
    searchTerm = { type: SearchTermType.PolygonId, polygonId };
  } else if (destination) {
    searchTerm = deserializeConstraintText(destination).searchTerm;
  } else {
    throw new Error('Missing search term for own stay ingredient');
  }

  const ownStayIngredient = new OwnStayIngredient(searchTerm);
  ownStayIngredient.numberOfNights = numberOfNights ?? undefined;
  ownStayIngredient.subIngredients =
    subIngredients?.map((subIngredient: ExposedActivityIngredient) =>
      createActivityIngredient(subIngredient, ownStayIngredient.ingredientId)
    ) ?? [];

  return ownStayIngredient;
}
